export function formatDateTime(inputdate) {
  if (inputdate && inputdate !== "") {
    let dateObj = new Date(inputdate);
    let month = getMonth(dateObj);
    let date = getDate(dateObj);
    let currentDate = `${date}/${month}/${dateObj.getFullYear()} ${('0' + dateObj.getHours()).slice(-2)}:${('0' + dateObj.getMinutes()).slice(-2)}:${('0' + dateObj.getSeconds()).slice(-2)}`;
    return currentDate;
  } else {
    return inputdate;
  }
}

export function formatDate(inputdate) {
  if (inputdate && inputdate !== "") {
    let dateObj = new Date(inputdate);
    let month = getMonth(dateObj);
    let date = getDate(dateObj);
    let currentDate = `${date}/${month}/${dateObj.getFullYear()}`;
    return currentDate;
  } else {
    return inputdate;
  }
}

const getMonth = (dateObj) => {
  let currentMonth =
    dateObj.getMonth() + 1 <= 9
      ? "0" + (dateObj.getMonth() + 1)
      : dateObj.getMonth() + 1;
  return currentMonth;
};

const getDate = (dateObj) => {
  let currDate =
    dateObj.getDate() <= 9 ? "0" + dateObj.getDate() : dateObj.getDate();
  return currDate;
};

export function convertDateTimetoDateFormat(dateTime) {
  if (dateTime && dateTime !== "" && dateTime !== "null") {
    let date_obj = new Date(dateTime);
    let month = getMonth(date_obj);
    let date = getDate(date_obj);
    let currentDate = `${date_obj.getFullYear()}-${month}-${date}`;
    return currentDate;
  } else {
    return "";
  }
}

export function convertDateForPicker(dateTime) {
  if (dateTime && dateTime !== "" && dateTime !== "null") {
    let date_obj = new Date(dateTime);
    let month = getMonth(date_obj);
    let date = getDate(date_obj);
    let currentDate = `${month}/${date}/${date_obj.getFullYear()}`;
    return currentDate;
  } else {
    return "";
  }
}

export function addDays(date, days) {
  let result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
